import WidgetSearchClassRequestModel from '../../generated/types/model/resource/WidgetSearchClassRequestModel';

export default class WidgetSearchClassRequestViewModel extends WidgetSearchClassRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
